import TsaOrderCancelSuccessDialog from '@/components/orderCancelSuccessDialog'
let $vm
let watcher

const plugin = {
  install (vue, pluginOptions = {}) {
    const OrderCancelSuccessDialog = vue.extend(TsaOrderCancelSuccessDialog)
    if (!$vm) {
      $vm = new OrderCancelSuccessDialog({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const orderCancelSuccessDialog = {
      show (options = {}) {
        $vm.show = true
        $vm.type = options.type || 1
        $vm.traceMap = options.traceMap || {}
      },
      update (payLeave) {
        $vm.payLeave = payLeave || {}
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaOrderCancelSuccessDialog) {
      vue.prototype.$TsaOrderCancelSuccessDialog = orderCancelSuccessDialog
    }
  }
}

export default plugin